<template>
  <div class="season-pass-rewards-strip">
    <div ref="container" class="rewards-container" @wheel.prevent="onWheel">
      <div class="rewards-content">
        <div
          v-for="(level, index) in pass.levels"
          :key="'slot-' + index"
          class="tier-slot"
        >
          <SeasonPassLockPanel
            v-if="lockPanelLevel && level.id === lockPanelLevel.id"
            :level="level"
            :unlock-in-flight="unlockInFlight"
            @unlock-level="$emit('unlock-level', $event)"
          />
          <SeasonPassTierRow
            :id="'tier-row-' + index"
            :level="level"
            :index="index"
            :pass="pass"
            :rewards="rewards[index] || {}"
            :is-current="index === currentLevelIndex"
            :is-locked="index > currentLevelIndex"
            :is-completed="index < currentLevelIndex"
            :user-progress="isCurrent(index) ? userProgress : null"
            :current-progress="userProgress"
            :is-premium="isPremium"
            :tickets-enabled="ticketsEnabled"
            @buy-tier-offer="$emit('buy-tier-offer', $event)"
          />
        </div>
      </div>
    </div>

    <div class="scroll-buttons">
      <div class="button-left pointer" @click="scroll(-scrollSpeed)"></div>
      <div class="button-right pointer" @click="scroll(scrollSpeed)"></div>
    </div>
  </div>
</template>

<script>
import SeasonPassTierRow from "./season-pass-tier-row.vue";
import SeasonPassLockPanel from "./season-pass-lock-panel.vue";

export default {
  name: "SeasonPassRewardsStrip",
  components: { SeasonPassTierRow, SeasonPassLockPanel },
  props: {
    pass: {
      type: Object,
      required: true,
    },
    rewards: {
      type: Array,
      default: () => [],
    },
    currentLevelIndex: {
      type: Number,
      default: 0,
    },
    userProgress: {
      type: Number,
      default: 0,
    },
    isPremium: {
      type: Boolean,
      default: false,
    },
    ticketsEnabled: {
      type: Boolean,
      default: false,
    },
    unlockInFlight: {
      type: Boolean,
      default: false,
    },
    lockPanelLevel: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      scrollSpeed: 800,
      isScrolling: false,
    };
  },
  watch: {
    currentLevelIndex() {
      this.scheduleScrollToCurrent();
    },
    rewards() {
      this.scheduleScrollToCurrent();
    },
  },
  mounted() {
    this.scheduleScrollToCurrent();
  },
  methods: {
    isCurrent(index) {
      return index === this.currentLevelIndex;
    },
    scroll(x) {
      if (this.isScrolling) return;
      this.isScrolling = true;
      const container = this.$refs.container;
      if (!container) return;
      container.scrollBy({ left: x, behavior: "smooth" });
      setTimeout(() => {
        this.isScrolling = false;
      }, Math.abs(x) / 2);
    },
    onWheel(event) {
      const container = this.$refs.container;
      if (!container) return;
      const delta = event.deltaY || event.deltaX;
      if (!delta) return;
      container.scrollLeft += delta;
    },
    scrollToCurrent() {
      const node = document.getElementById(
        "tier-row-" + this.currentLevelIndex
      );
      if (!node) return;
      const container = this.$refs.container;
      if (!container) return;
      const left =
        node.offsetLeft - container.clientWidth / 2 + node.offsetWidth / 2;
      container.scrollTo({ left, top: 0 });
    },
    scheduleScrollToCurrent() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.scrollToCurrent();
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.season-pass-rewards-strip {
  .rewards-container {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 405px;
    z-index: 1;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .rewards-content {
      width: auto;
      display: inline-flex;
      padding-left: 150px;
      padding-right: 150px;

      .tier-slot {
        display: contents;
      }
    }
  }

  .scroll-buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    z-index: 30;
    pointer-events: none;

    .pointer {
      pointer-events: auto;
      cursor: pointer;
      width: 58px;
      height: 58px;
      position: absolute;
      top: 20px;
    }

    .button-left {
      left: 24px;
      background: url(~@/assets/img/common/green_arrow_left.png) left/100% 100%
        no-repeat;
      &:hover {
        filter: $hover-shadow;
      }
    }

    .button-right {
      right: 24px;
      background: url(~@/assets/img/common/green_arrow_right.png) left/100% 100%
        no-repeat;
      &:hover {
        filter: $hover-shadow;
      }
    }
  }
}
</style>
